/* eslint-disable react/no-unused-prop-types */
import { PureComponent } from 'react';
import PropTypes from 'prop-types';

class BaseIcon extends PureComponent {}

BaseIcon.propTypes = {
  fillColor: PropTypes.string.isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
};

BaseIcon.defaultProps = {
  height: '100%',
  width: '100%',
};

export default BaseIcon;
